import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs-make";

export default class extends Controller {
  static values = {
    reorderUrl: String,
  };

  connect() {
    this.setupSortable();
  }

  disconnect() {
    this.destroySortable();
  }

  setupSortable() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-content-handle]",
      filter: "[data-sortable-exclude]",
      fallbackOnBody: true,
      forceFallback: true,
      swapThreshold: 0.65,
      onMove: (event) => {
        return !event.related.hasAttribute("data-sortable-exclude");
      },
      onStart: () => {
        this.element.style.userSelect = "none";
      },
      onEnd: (...args) => {
        this.element.style.userSelect = "";
        this.onReorder(...args);
      },
    });
  }

  destroySortable() {
    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = null;
    }
  }

  onReorder(event) {
    const sortOrderId = event.item.dataset.sortOrderId;
    if (!sortOrderId) return;

    const newPosition = event.newIndex + 1;

    this.patchReorder(sortOrderId, newPosition);
  }

  get csrfToken() {
    return document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");
  }

  patchReorder(sortOrderId, newPosition) {
    const data = new FormData();
    data.append("sort_order_id", sortOrderId);
    data.append("new_position", newPosition);

    fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.csrfToken,
      },
      body: data,
    })
      .then((response) => {
        if (!response.ok) throw new Error("Reorder failed");
      })
      .catch((error) => {
        console.error("Reorder error:", error);
        window.location.reload();
      });
  }
}
